<ng-container *ngIf="brandCategory$ | async as brandCategory">
  <a
    class="link-primary text-uppercase mb-2"
    [routerLink]="
      { cxRoute: 'search', params: { query: brandCategory.name } } | cxUrl
    ">
    {{ brandCategory.name }}
  </a>
</ng-container>
